export default __webpack_public_path__ + "static/2_Braces-b1c446ed72c830091f0cde357c68d34a.jpg";